<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->
<template>
	<ValidationObserver ref="observer" v-slot="{ validate, reset, errors }" slim>
		<BForm :novalidate="true" @submit.prevent="onSubmit" :clearErrors="clearErrors">
			<slot :validate="validate" :reset="reset" :errors="errors"></slot>
		</BForm>
	</ValidationObserver>
</template>

<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { ValidationObserver } from 'vee-validate';
import { BForm } from 'bootstrap-vue';

/**
 * Component renders a form.
 */
@Component({
	name: 'BaseForm',
	components: {
		BForm,
		ValidationObserver
	}
})
export default class BaseForm extends Vue {
	isvalid = true;
	/**
	 * Handle onsubmit event
	 * @param {function} validate The validate function
	 */
	async onSubmit() {
		//console.log(Object.entries(this.$refs.observer.fields));
		const valid = await this.$refs.observer.validate();
		if (valid && this.isvalid) {
			this.$emit('submit');
		} else {
			//console.log(this.$refs.observer.errors);
			//delete this.$refs.observer.errors['File Selection'];
			//delete this.$refs.observer.errors['Sélection du fichier'];
			let temp = [];
			let i = 0;
			//console.log(Object.entries(this.$refs.observer.errors)[0][1][0]);
			//console.log(Object.entries(this.$refs.observer.errors)[1][0], Object.entries(this.$refs.observer.errors)[1][1][0]);
			for (let index = 0; index < Object.entries(this.$refs.observer.errors).length; index++) {
				//const element = Object.entries(this.$refs.observer.errors)[index];
				//console.log(element[1].length);

				//console.log(Object.entries(this.$refs.observer.errors)[index][1].length);
				if (Object.entries(this.$refs.observer.errors)[index][1].length > 0) {
					temp[i] = Object.entries(this.$refs.observer.errors)[index];
					i += 1;
				}
			}
			//console.log(temp);
			//emit the error

			this.$emit('validationErrors', temp);
			const firstError = Object.entries(this.$refs.observer.errors).find(entry => {
				const [key, value] = entry;
				return key && value && value.length > 0;
			});
			if (firstError) {
				//const [refKey] = firstError;
				//this.$refs.observer.refs[refKey].$el.querySelector('.form-control').focus();
			}
		}
	}

	clearErrors() {
		this.$refs.observer.reset();
	}
}
</script>
